import React, { useState } from "react";
import Button from "@mui/material/Button";
import { EditIcon } from "../../atoms/icons/edit";
import { AvailableLoanOptionsIcon } from "../../atoms/icons/available-loan-options";
import { InfoText } from "./molecules/InfoText";
import { LoanComparisonIcon } from "../../atoms/icons/loan-comarison";
import { QuoteCard } from "./molecules/QuoteCard";
import {
  COMPARE_TOTAL_CASH_TO_CLOSE_ITEMS,
  COMPARE_TOTAL_CLOSING_COST_ITEMS,
  isRefinance,
} from "../../util/compare_utils";
import { CompareViewAccordion, PaperItem } from "./molecules/CustomAccordion";
import { TopStatsBarDesktop } from "./molecules/TopStatsBarDesktop";
import { styled } from "@mui/material";
import { TooltipCombo } from "./molecules/TooltipCombo";

const RelativeParent = styled("div")`
  position: relative;
  width: 100%;
`;

const ToolTipComparePositioner = styled("div")`
  position: absolute;
  top: 4px;
  left: 18px;
`;

export const ComparisonViewDesktop = ({
  enteredData,
  comparedQuotes,
  setIsComparisonView,
  setShowAddModal,
  setShowSettingsModal,
  setComparedId,
  isComparedIds,
  onEditClick,
  onSelect,
  content,
}) => {
  const [openArray, setOpenArray] = useState([]);
  const { price, downPayment, zip, creditScore } = enteredData;
  return (
    <div className="comparison-desktop">
      <div className="comparison-available-options">
        <div className="flex-row align-items-center">
          <AvailableLoanOptionsIcon className="margin-right" fill="white" />
          <div className="bold">Available Loan Options</div>
        </div>
        <Button
          variant="contained"
          sx={{
            borderRadius: "20px",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            color: "white",
            paddingLeft: "40px",
            paddingRight: "40px",
            display: "flex",
            alignItems: "center",
            textTransform: "none",
          }}
          startIcon={<EditIcon fill="white" width="16" height="16" />}
          onClick={() => setIsComparisonView(false)}
        >
          Edit Loan Selection
        </Button>
      </div>
      <div className="irq-desktop">
        {content.tip2 && (
          <div className="irq-right-side-wrapper">
            <InfoText tip={content.tip2} />
          </div>
        )}

        <TopStatsBarDesktop
          creditScore={creditScore}
          downpayment={downPayment}
          price={price}
          zip={zip}
          setShowSettingsModal={setShowSettingsModal}
        />

        <div className="comparison-main-section-wrapper">
          <div className="comparison-cards-wrapper">
            <div className="loan-icon-wrapper">
              <LoanComparisonIcon fill="white" />
              Loan Comparison
            </div>
            <div className="quote-cards-wrapper">
              <div className="quote-headings">
                <div className="quote-card-icon-wrapper bold medium-large">
                  Type
                </div>
                <div className="quote-heading-text bold medium-large">Term</div>
                <div className="quote-heading-text bold medium-large">Rate</div>
                <div className="quote-heading-text bold medium-large">APR</div>
                <div className="horizontal-line" />
                <div className="pie-chart-heading">
                  <div className="quote-heading-text bold medium-large">
                    Monthly Payment
                  </div>
                </div>
                <div className="quote-heading-text medium-large">Principal</div>
                <div className="quote-heading-text medium-large">Interest</div>
                <RelativeParent>
                  <div className="quote-heading-text medium-large">PMI</div>
                  <ToolTipComparePositioner>
                    <TooltipCombo tip={content.tooltip1} />
                  </ToolTipComparePositioner>
                </RelativeParent>
                <div className="quote-heading-text medium-large">Insurance</div>
                <div className="quote-heading-text medium-large quote-heading-taxes">
                  Taxes
                </div>
                <div className="horizontal-line" />

                <CompareViewAccordion
                  title="Total Closing Costs"
                  openArray={openArray}
                  setOpenArray={setOpenArray}
                  name="ClosingCosts"
                  isFirst
                  tooltipText={content.tooltip2}
                >
                  {COMPARE_TOTAL_CLOSING_COST_ITEMS.map((item, index) => (
                    <CompareViewAccordion
                      title={item.title}
                      openArray={openArray}
                      setOpenArray={setOpenArray}
                      name={item.name}
                      isMini
                      hasIcon={!!item.subtitles.length}
                      key={item.title}
                      tooltipText={content[`tooltip${index + 3}`]}
                    >
                      {item.subtitles.map((subtitle) => (
                        <PaperItem key={subtitle} padding="5px 12px 5px 0">
                          {subtitle}
                        </PaperItem>
                      ))}
                    </CompareViewAccordion>
                  ))}
                </CompareViewAccordion>

                <div className="horizontal-line" />

                <CompareViewAccordion
                  title="Total Cash to Close"
                  name="CashToClose"
                  openArray={openArray}
                  setOpenArray={setOpenArray}
                  tooltipText={content.tooltip8}
                >
                  {COMPARE_TOTAL_CASH_TO_CLOSE_ITEMS.filter((item, index) => {
                    if(index !== 3) {
                      return true;
                    }
                    return !isRefinance();
                  }).map((item, index) => (
                    <CompareViewAccordion
                      title={item.title}
                      openArray={openArray}
                      setOpenArray={setOpenArray}
                      name={item.name}
                      isMini
                      hasIcon={!!item.subtitles.length}
                      key={item.title}
                      tooltipText={content[`tooltip${index + 9}`]}
                    >
                      {item.subtitles.map((subtitle) =>
                        subtitle === "Down Payment" && isRefinance() ? null : (
                          <PaperItem key={subtitle} padding="5px 12px 5px 0">
                            {subtitle}
                          </PaperItem>
                        )
                      )}
                    </CompareViewAccordion>
                  ))}
                </CompareViewAccordion>
                <div className="horizontal-line" />
              </div>
              {comparedQuotes.map((quote) => (
                <QuoteCard
                  quote={quote}
                  key={quote.id}
                  openArray={openArray}
                  setShowAddModal={setShowAddModal}
                  enteredData={enteredData}
                  setComparedId={setComparedId}
                  isComparedIds={isComparedIds}
                  onEditClick={onEditClick}
                  onSelect={() => onSelect(quote)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
